import { useCallback } from 'react';
import { useSnackbar } from 'notistack';
import type { SnackbarKey } from 'notistack';

import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

interface Props {
  readonly snackbarKey: SnackbarKey;
}

export const SnackbarCloseButton = ({ snackbarKey }: Readonly<Props>) => {
  const { closeSnackbar } = useSnackbar();

  const handleClick = useCallback(() => {
    closeSnackbar(snackbarKey);
  }, [closeSnackbar, snackbarKey]);

  return (
    <IconButton
      aria-label="Fermer"
      color="inherit"
      onClick={handleClick}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};
